import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Table from 'britive-design-system/core/components/table'
import Spinner from 'britive-design-system/core/components/spinner'
import Typography from 'britive-design-system/core/components/typography'
import { prepareRowsForDownload } from '../../../../routes/admin/BrokersAndBrokerPools/Brokers/utils'
import downloadFileInBackground from 'utils/downloadFileInBackground'
import downloadIcon from 'static/images/download.svg'
import folderIcon from 'static/images/folder.svg'
import toast from 'utils/toast'
import '../index.scss'

const CSS_CLASSNAME_PREFIX = 'cli-package-list'

const DownloadCliPackages = ({ onClose }) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const { loading, data } = useSelector(state => state.cliPackageReducer)

  const downloadFile = row => {
    try {
      setIsDownloading(true)
      downloadFileInBackground(row.url, () => setIsDownloading(false))
    } catch {
      setIsDownloading(false)
      toast({
        title: 'Unable to download the file.',
        type: 'error',
        id: 'download-broker-error',
      })
    }
  }

  const columns = [
    {
      headerName: 'Expand the package type to view available installer(s)',
      allowExpand: true,
      renderColumn: row => {
        if (row.key && row.url?.length) {
          return (
            <div className={`${CSS_CLASSNAME_PREFIX}-package-item`}>
              <a href="#" onClick={() => downloadFile(row)}>
                <img
                  className={`${CSS_CLASSNAME_PREFIX}-package-item-icon`}
                  src={downloadIcon}
                />
                <Typography variant="label1">{row.key}</Typography>
              </a>
            </div>
          )
        }

        return (
          <div className={`${CSS_CLASSNAME_PREFIX}-package-group`}>
            <img
              className={`${CSS_CLASSNAME_PREFIX}-package-group-icon`}
              src={folderIcon}
            />
            <Typography variant="heading6">{row.key}</Typography>
          </div>
        )
      },
    },
  ]

  return (
    <>
      {(loading || isDownloading) && (
        <Spinner size="medium" message="Loading." overlay />
      )}
      <div className="download-header">
        <div className="download-header-container">
          <span className="header-text">Download the CLI package</span>
          <span onClick={onClose}>
            <i className="fa fa-times" />
          </span>
        </div>
      </div>
      <div className={`${CSS_CLASSNAME_PREFIX}-table-list`}>
        <Table
          resizableColumns
          columns={columns}
          noDataMessage={
            !loading ? 'No CLI package installers have been added yet.' : ''
          }
          rows={prepareRowsForDownload(data || {}) || []}
        />
      </div>
    </>
  )
}

export default DownloadCliPackages
